import React, { Component, Fragment } from "react";
import { Translate } from "react-localize-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import AutoRenewOfferModal from "../AutoRenew/AutoRenewOfferModal";
import {
  fetchAutoPayment,
  setAutoPaymentAccepted,
  shouldOfferAutoRenew,
  snoozeOffer,
} from "../../utils/auto-payment";

const storeId = process.env.REACT_APP_STOREID;
const base_services_api = process.env.REACT_APP_SERVICES_API_BASE;

// Дараагийн автомат суутгалаас өмнө хэдэн хоногийн дотор баталгаажуулалт асуух вэ
const RENEWAL_CONFIRM_WINDOW_DAYS = 10;
const DAY_MS = 24 * 60 * 60 * 1000;

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileName: "",
      profileEmail: "",
      profileMsisdn: "",
      subscriptionSourceType: "",
      autoRenewAccepted: false,
      userId: null,
      cardNumber: null,
      // Автомат сунгалтын дараагийн суутгалын огноо (auto-payment бичлэгийн activeTo)
      nextChargeDate: null,
      autoPaymentAmount: null,
      showRenewalConfirm: false,
      renewalUpdating: false,
      // Карт холбосон ч сунгалт идэвхгүй -> идэвхжүүлэх санал
      showAutoRenewOffer: false,
      autoRenewOfferError: false,
      autoRenewOfferDone: false,
    };
  }

  componentDidMount() {
    this.loadProfile();
  }

  formatDate = (date) => date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();

  fetchAutoRenewStatus = (userId) => {
    fetchAutoPayment(userId, this.props.auth.access_token)
      .then((record) => {
        const result = record || {};
        const accepted = result.accepted === true;
        const nextChargeDate = result.activeTo ? new Date(result.activeTo) : null;
        const validDate = nextChargeDate && !isNaN(nextChargeDate.getTime()) ? nextChargeDate : null;

        this.setState(
          {
            autoRenewAccepted: accepted,
            cardNumber: result.cardNumber,
            nextChargeDate: validDate,
            autoPaymentAmount: result.amount || null,
            showAutoRenewOffer: shouldOfferAutoRenew(record, userId),
          },
          () => this.maybeAskRenewalConfirm(userId),
        );
      })
      .catch((err) => {
        console.error("Failed to fetch auto-renew status:", err);
      });
  };

  acceptAutoRenewOffer = () => {
    this.setState({ autoRenewOfferError: false });
    this.setAutoRenew(
      true,
      () => this.setState({ autoRenewOfferDone: true }),
      () => this.setState({ autoRenewOfferError: true }),
    );
  };

  declineAutoRenewOffer = () => {
    snoozeOffer(this.state.userId);
    this.setState({ showAutoRenewOffer: false });
  };

  loadProfile = () => {
    axios
      .get(`${base_services_api}/users/${this.props.auth.sub}/profile`, {
        headers: { StoreId: storeId, Authorization: `Bearer ${this.props.auth.access_token}` },
      })
      .then((resp) => {
        console.log("profiel resp:", resp);
        /* Багцгүй (хугацаа нь дууссан) хэрэглэгчид Subscriptions хоосон —
           тэдэнд ч автомат сунгалтын санал хэрэгтэй тул нэвтэрсэн ID-г ашиглана. */
        const userId = resp.data.Subscriptions[0]?.UserId || this.props.auth.sub;
        this.setState({
          profileName: resp.data.FirstName,
          profileEmail: resp.data.PrimaryEmail,
          profileMsisdn: resp.data.PhoneNumber,
          subscriptionSourceType: resp.data.Subscriptions[0]?.Source?.SourceType ?? undefined,
          userId: userId,
        });

        if (userId) {
          this.fetchAutoRenewStatus(userId);
        }
      })
      .catch((err) => {
        console.error("Failed to load profile:", err);
      });
  };

  // Өнөөдрөөс дараагийн суутгал хүртэлх бүтэн хоног (өнгөрсөн бол сөрөг)
  daysUntilCharge = () => {
    const { nextChargeDate } = this.state;
    if (!nextChargeDate) return null;
    return Math.ceil((nextChargeDate.getTime() - Date.now()) / DAY_MS);
  };

  /* Тухайн суутгалын огноонд хэрэглэгч "Үргэлжлүүлэх" гэж нэгэнт
     баталсан бол дахин асуухгүй. Огноогоор түлхүүрлэнэ — дараагийн
     сарын суутгал ойртоход дахин асууна. */
  renewalConfirmKey = (userId) =>
    `autoRenewConfirmed:${userId}:${this.state.nextChargeDate.toISOString().slice(0, 10)}`;

  maybeAskRenewalConfirm = (userId) => {
    if (!this.state.autoRenewAccepted || !this.state.nextChargeDate) return;
    const days = this.daysUntilCharge();
    if (days === null || days < 0 || days > RENEWAL_CONFIRM_WINDOW_DAYS) return;
    try {
      if (window.localStorage.getItem(this.renewalConfirmKey(userId)) === "1") return;
    } catch (e) {
      // localStorage хаалттай бол зүгээр л асууна
    }
    this.setState({ showRenewalConfirm: true });
  };

  // Зөвшөөрсөн: сунгалт хэвээр, энэ огноонд дахин асуухгүй
  confirmRenewal = () => {
    try {
      window.localStorage.setItem(this.renewalConfirmKey(this.state.userId), "1");
    } catch (e) {
      // ignore
    }
    this.setState({ showRenewalConfirm: false });
  };

  // Зөвшөөрөөгүй: автомат сунгалтыг цуцална
  declineRenewal = () => {
    this.setAutoRenew(false, () => this.setState({ showRenewalConfirm: false }));
  };

  // Гадна дарж эсвэл × -ээр хаасан: юу ч өөрчлөхгүй, сунгалт хэвээр
  dismissRenewalConfirm = () => {
    this.setState({ showRenewalConfirm: false });
  };

  onEditClick = () => {
    this.props.history.push("/profile-edit");
  };

  onPremiumClick = () => {
    this.props.history.push("/premium");
  };

  toggleAutoRenew = () => {
    this.setAutoRenew(!this.state.autoRenewAccepted);
  };

  setAutoRenew = (newAcceptedValue, onDone, onError) => {
    if (this.state.renewalUpdating) return;
    this.setState({ renewalUpdating: true });

    setAutoPaymentAccepted(this.state.userId, newAcceptedValue, this.props.auth.access_token)
      .then((resp) => {
        console.log("Auto-renew toggle response:", resp);
        this.setState({
          autoRenewAccepted: newAcceptedValue,
          renewalUpdating: false,
        });
        if (onDone) onDone();
      })
      .catch((err) => {
        console.error("Failed to toggle auto-renew:", err);
        this.setState({ renewalUpdating: false });
        if (onError) onError(err);
      });
  };

  renderRenewalConfirm() {
    if (!this.state.showRenewalConfirm || !this.state.nextChargeDate) return null;
    const days = this.daysUntilCharge();
    const { autoPaymentAmount, cardNumber, renewalUpdating } = this.state;

    return (
      <div className="approval-modal-overlay" onClick={this.dismissRenewalConfirm}>
        <div
          className="approval-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="renewal-confirm-title"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close-btn" onClick={this.dismissRenewalConfirm} aria-label="×">
            ×
          </button>
          <h3 className="modal-title" id="renewal-confirm-title">
            <Translate id="profile.renewal-confirm-title" />
          </h3>
          <div className="approval-content">
            <p className="modal-main-text">{this.formatDate(this.state.nextChargeDate)}</p>
            <p className="modal-subtitle">
              <Translate
                id="profile.renewal-confirm-text"
                data={{ days: Math.max(days, 0) }}
              />
              {autoPaymentAmount ? ` (${Number(autoPaymentAmount).toLocaleString()}₮)` : ""}
              {cardNumber ? ` · ${cardNumber}` : ""}
            </p>
          </div>
          <div className="approval-buttons">
            <button className="btn-approve" onClick={this.confirmRenewal} disabled={renewalUpdating}>
              <Translate id="profile.renewal-continue" />
            </button>
            <button className="btn-decline" onClick={this.declineRenewal} disabled={renewalUpdating}>
              <Translate id="profile.renewal-cancel" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let subscriptions;

    if (this.props.subscriptions.length > 0) {
      subscriptions = this.props.subscriptions.map((subscription) => (
        <div className="redeem-sidebar" key={subscription.SubscriptionId}>
          <div className="profile-heading">
            <Translate id="title.profile-details" />{" "}
            <button className="btn-edit" onClick={this.onEditClick}>
              <Translate id="button.edit" />
            </button>
          </div>

          {this.state.profileName ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.name" />
              </div>
              <span className="right">{this.state.profileName}</span>
            </div>
          ) : null}

          {this.state.profileEmail ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.emailaddress" />
              </div>
              <span>{this.state.profileEmail}</span>
            </div>
          ) : null}

          <div className="redeem-section">
            <div className="redeem-title">
              <Translate id="profile.auto-renew" />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>
                {this.state.autoRenewAccepted ? (
                  <Translate id="profile.active" />
                ) : (
                  <Translate id="profile.inactive" />
                )}
              </span>
              <button
                className="btn-edit"
                onClick={this.toggleAutoRenew}
                style={{ marginLeft: "auto" }}
              >
                {this.state.autoRenewAccepted ? (
                  <Translate id="button.cancel" />
                ) : (
                  <Translate id="button.enable" />
                )}
              </button>
            </div>
          </div>

          {this.state.autoRenewAccepted && this.state.nextChargeDate ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.next-renewal" />
              </div>
              <span>{this.formatDate(this.state.nextChargeDate)}</span>
            </div>
          ) : null}

          {this.state.cardNumber && this.state.cardNumber !== "" ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.card-number" />
              </div>
              <span>{this.state.cardNumber}</span>
            </div>
          ) : null}

          {this.state.profileMsisdn && this.state.profileMsisdn !== "" ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.msisdn" />
              </div>
              <span>{this.state.profileMsisdn}</span>
            </div>
          ) : null}

          <div className="redeem-section">
            <div className="redeem-title">
              <Translate id="profile.subscription" />
            </div>
            <Translate>
              {({ translate }) => (
                <span>
                  {new Date(subscription.EndDate) > new Date()
                    ? translate("profile.active")
                    : subscription.IsAutoRenew
                    ? translate("profile.active")
                    : translate("profile.inactive")}
                  {new Date(subscription.EndDate) > new Date() &&
                  subscription.PackageCost?.Name?.[0]?.Value
                    ? " - " + subscription.PackageCost.Name[0].Value
                    : ""}
                </span>
              )}
            </Translate>
          </div>

          <div className="redeem-section">
            <div className="redeem-title">
              <Translate id="profile.start-date" />
            </div>
            <span>{this.formatDate(new Date(subscription.StartDate))}</span>
          </div>

          <div className="redeem-section">
            <div className="redeem-title">
              <Translate id="profile.end-date" />
            </div>
            <span>{this.formatDate(new Date(subscription.EndDate))}</span>
          </div>

          {this.state.subscriptionSourceType && (
            <div className="redeem-section">
              <div>
                <small>
                  {(this.state.subscriptionSourceType === "Apple IAP" && (
                    <Translate id="subscription.apple" />
                  )) ||
                    (this.state.subscriptionSourceType === "Google Play" && (
                      <Translate id="subscription.google" />
                    ))}
                </small>
              </div>
            </div>
          )}
        </div>
      ));
    } else {
      subscriptions = (
        <div className="redeem-sidebar">
          <div className="profile-heading">
            <Translate id="title.profile-details" />{" "}
            <button className="btn-edit" onClick={this.onEditClick}>
              <Translate id="button.edit" />
            </button>
          </div>

          {this.state.profileName ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.name" />
              </div>
              <span>{this.state.profileName}</span>
            </div>
          ) : null}

          {this.state.profileEmail ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.emailaddress" />
              </div>
              <span>{this.state.profileEmail}</span>
            </div>
          ) : null}

          {this.state.profileMsisdn && this.state.profileMsisdn !== "" ? (
            <div className="redeem-section">
              <div className="redeem-title">
                <Translate id="profile.msisdn" />
              </div>
              <span>{this.state.profileMsisdn}</span>
            </div>
          ) : null}

          <div className="redeem-section">
            <div className="redeem-title">
              <Translate id="profile.subscription" />
            </div>
            <span>
              <Translate id="profile.inactive" />
              <div>
                <button className="btn-profile" onClick={this.onPremiumClick}>
                  <Translate id="button.go-premium" />
                </button>
              </div>
            </span>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        {subscriptions}
        {this.renderRenewalConfirm()}
        <AutoRenewOfferModal
          open={this.state.showAutoRenewOffer && !this.state.showRenewalConfirm}
          cardNumber={this.state.cardNumber}
          busy={this.state.renewalUpdating}
          error={this.state.autoRenewOfferError}
          done={this.state.autoRenewOfferDone}
          onAccept={this.acceptAutoRenewOffer}
          onDecline={this.declineAutoRenewOffer}
          onDismiss={() => this.setState({ showAutoRenewOffer: false })}
        />
      </Fragment>
    );
  }
}

export default withRouter(Profile);
